export default "__VITE_ASSET__Bmj89RTK__"